import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Autocomplete,
    TextField,
    Divider,
    Typography,
} from "@mui/material";
import { Toolbar, } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Header from "../../../Layout/Header";
// import { callApi } from "../../commonapicall/fetchdata";
// import { API_ENDPOINTS } from "../../../config/api/apiCall"";
import CallAlertBar from "../../../Layout/Alertbar";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import AttendanceActionMenu from "./ActionMenu";
import ViewMonthlyAttendance from "./ViewMonthlyAttendance";
const MarkAttendance = ({ handleViewAttendance, AttendanceDetails }) => {
    const [attendanceDate, setAttendanceDate] = useState(dayjs());
    const [checkInTime, setCheckInTime] = useState(null);
    const [checkOutTime, setCheckOutTime] = useState(null);
    const [durationMins, setDurationMins] = useState(0);
    const [status, setStatus] = useState("");
    const [manualEntry, setManualEntry] = useState(true);
    const [employeeID, setEmployeeID] = useState("");
    const [attendaceID, setAttendaceID] = useState(0);
    const [device, setDevice] = useState("Manual Entry");
    const [location, setLocation] = useState("");

    const [errorMessages, setErrorMessages] = useState({});
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [employee, setEmployee] = useState('');
    const [employeelist, setEmployeelist] = useState([]);
    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [shiftCodes, setShiftCodes] = useState([]);
    const [winderShiftID, setWinderShiftID] = useState(0);

    const [title, setTitle] = useState('New Attendance Entry');
    const [disableEmployee, setdisableEmployee] = useState(false);
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [viewMonthlyAttendance, setViewMonthlyAttendance] = useState(false);

    const handleCalculateDuration = () => {
        if (checkInTime && checkOutTime) {

            const duration = dayjs(checkOutTime).diff(dayjs(checkInTime), "minute");
            setDurationMins(duration);
        }
    };




    const ViewHideMsg = (msg, securityvalue, open) => {
        setParentRollSeverityvalue(securityvalue);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(securityvalue);
        setParentRollMsgOpen(open);
    }

    const validateEmployeeAttendance = () => {

        const errors = {};
        if (!employeeID) {
            ViewHideMsg("Employee is required.", 'warning', true);
            errors.employeeID = "Employee is required.";
        } else if (!attendanceDate) {
            ViewHideMsg("Attendance Date is required.", 'warning', true);
            errors.attendanceDate = "Attendance is required.";
        } else if (!checkInTime) {
            ViewHideMsg("CheckIn Time is required.", 'warning', true);
            errors.checkInTime = "CheckIn Time is required.";
        }
        else if (!checkOutTime) {
            ViewHideMsg("CheckOut Time is required.", 'warning', true);
            errors.checkOutTime = "CheckOut Time is required.";
        }
        else if (checkInTime > checkOutTime) {
            ViewHideMsg("CheckIn time should be less than to CheckOut time.", 'warning', true);
            errors.timeComparison = "CheckIn time should be less than to CheckOut time.";
        }
        else if (!status) {
            ViewHideMsg("Attendance status is required.", 'warning', true);
            errors.status = "Attendance status is required.";
        }
        else if (!location) {
            ViewHideMsg("location is required.", 'warning', true);
            errors.location = "Location is required.";
        }
        else if (!winderShiftID) {
            ViewHideMsg("Shift is required.", 'warning', true);
            errors.shiftID = "Shift is required.";
        }

        return errors;
    };

    const handleSubmit = () => {
        const errors = validateEmployeeAttendance();

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return;
        }
        const validLocations = ["local", "overseas"];

        if (!validLocations.includes(location?.toLowerCase())) {
            alert("Invalid location. Please enter either 'local' or 'overseas'.");
            return; // stop further execution
        }


        const requestBody = {
            p_companyid: localStorage.getItem('companyid'),
            obj: [
                {
                    id_attendance: attendaceID,
                    id_employee: employeeID,
                    attendance_date: attendanceDate.format("YYYY-MMM-DD"),
                    check_in_time: checkInTime ? checkInTime.format("YYYY-MMM-DD HH:mm") : null,
                    check_out_time: checkOutTime ? checkOutTime.format("YYYY-MMM-DD HH:mm") : null,
                    duration_mins: durationMins,
                    attendance_status: status,
                    device: device,
                    location: location,
                    manual_entry: manualEntry ? "Yes" : "No",
                    entry_date_time: attendanceDate.format("YYYY-MMM-DD"),
                    id_shift: winderShiftID,
                }]
        };

        callApi(API_ENDPOINTS.EMPLOYEE_ATTENDANCE_ADD_UPDATE, 'POST', { 'Content-Type': 'application/json' }, requestBody)
            .then(data => {
                // Update state with fetched data
                if (data !== null) {
                    setParentRollMessageValue(data);
                    setParentRollSeverityvalue('info');
                    setParentRollAlertTitleValue('Info');
                    setParentRollMsgOpen(true);

                    //   LoadCompanyDetails();
                }
                else {
                    setParentRollSeverityvalue('error');
                    setParentRollMessageValue(data);
                    setParentRollAlertTitleValue('Error');
                    setParentRollMsgOpen(true);
                }

            })
            .catch(error => {
                // // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });


    };

    const handleEmployeeChange = (event, value) => {
        if (value) {
            setEmployee(value);
            setEmployeeID(value.id);
        }
        else {
            setEmployee('');
            setEmployeeID('');
        }
    }

    useEffect(() => {
        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLists, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setEmployeelist(data);
                }
            })
            .catch(error => alert(error.message));
    }, []);



    const handleWinderShiftChange = (event, value) => {
        if (value !== undefined && value !== null) {
            if (value?.shiftid) {
                setWinderShiftCode(value);
                setWinderShiftID(value.shiftid);
            } else {
                setWinderShiftCode(null);
                setWinderShiftID(null);
            }

        }
    }

    // Get Shift Codes
    useEffect(() => {


        const para = {
            p_companyid: localStorage.getItem('companyid'),
        }

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setShiftCodes(data);
                    setWinderShiftCode(data[0]);
                    setWinderShiftID(data[0]?.shiftid || null);
                } else {
                    setShiftCodes([]);
                    setWinderShiftCode(null);
                    setWinderShiftID(null);
                }

            })
            .catch(error => {
                alert(error.message);
            });


    }, []);



    useEffect(() => {
        if (AttendanceDetails.shift_code !== null && AttendanceDetails.shift_code !== undefined && AttendanceDetails.employee_fullname !== null && AttendanceDetails.employee_fullname !== undefined) {
            if (shiftCodes.length === 0 && employeelist.length === 0) return;
            const shiftCode = shiftCodes.find((shift) => shift.shiftcode === AttendanceDetails.shift_code);

            if (shiftCode) {
                setWinderShiftCode(shiftCode);
                setWinderShiftID(shiftCode.shiftid);
            }

            const employeelocal = employeelist.find((emp) => emp.name === AttendanceDetails.employee_fullname);
            if (employeelocal) {
                setEmployee(employeelocal);
                setEmployeeID(employeelocal.id);
            }

            setAttendaceID(AttendanceDetails.id_attendance);
            setAttendanceDate(dayjs(AttendanceDetails.attendance_date));
            setCheckInTime(dayjs(AttendanceDetails.check_in_time));
            setCheckOutTime(dayjs(AttendanceDetails.check_out_time));
            setDurationMins(AttendanceDetails.duration_mins);
            setStatus(AttendanceDetails.attendance_status);
            setLocation(AttendanceDetails.location);
            // setShiftID(shiftCode.shiftid);
            setManualEntry(AttendanceDetails.manual_entry === 'Yes' ? true : false);
            setDevice(AttendanceDetails.device);
            setdisableEmployee(true);

            setTitle('Edit Attendance Entry');
            setAttendaceID(AttendanceDetails.id_attendance);
        }
        else {
            setTitle('New Attendance Entry');
            setdisableEmployee(false);
            setAttendaceID(0);
        }
    }, [AttendanceDetails, shiftCodes, employeelist]);


    const ClearAll = async () => {
        // Assuming you might have asynchronous operations in the future
        try {
            setEmployee('');
            setEmployeeID('');
            setAttendanceDate(dayjs());
            setCheckInTime(null);
            setCheckOutTime(null);
            setDurationMins(0);
            setStatus('');
            setLocation('');
            setWinderShiftID(0);
            setAttendaceID(0);
            setdisableEmployee(false);
            setTitle('New Attendance Entry');
            setParentRollMsgOpen(false);
        } catch (error) {
            console.error('Error during ClearAll:', error);

        }
    };



    const handlecallProcess = (buttonName) => {
        if (buttonName === 'report') {
            setViewMonthlyAttendance(true);
        }

        else if (buttonName === 'save') {
            handleSubmit();
        }
        else if (buttonName === 'clear') {
            ClearAll();
        }
    }

    const handleViewAttendanceList=()=>{
         setViewMonthlyAttendance(false);
    }

    return (
        <>
            {!viewMonthlyAttendance && (<>
                <Box padding={0}>

                    <AttendanceActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} title={title} callback={handleViewAttendance} />
                    <Divider />

                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Box padding={1}>

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                <Typography variant="h6">Employee Name</Typography>
                            </Grid>
                            <Grid item xs={12} sm={11} md={3.8} lg={4} xl={1.25}>
                                <Autocomplete
                                    fullWidth
                                    value={employee}
                                    onChange={handleEmployeeChange}
                                    size="small"
                                    style={{ fontSize: '12px' }}
                                    options={employeelist}
                                    getOptionLabel={(option) => option?.name || ''}
                                    disabled={disableEmployee}
                                    renderInput={(params) =>
                                        <TextField required
                                            placeholder="Select the Employee"
                                            {...params} variant="outlined" />}
                                />
                            </Grid>
                        </Grid>

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">

                                <Typography variant="h6">Location</Typography>

                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>

                                <TextField
                                    size="small"
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    fullWidth
                                />

                            </Grid>

                            <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                <Typography variant="h6" color={'secondary'}>(location should be local or overseas)</Typography>
                            </Grid>
                        </Grid>




                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">

                                <Typography variant="h6">Attendance Date</Typography>

                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                <FormControl size="small">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            // label="Attendance Date"
                                            value={attendanceDate}
                                            onChange={(newValue) => setAttendanceDate(newValue)}

                                            slotProps={{ textField: { size: 'small' } }}
                                            renderInput={(props) => <TextField {...props} />}
                                            format="DD-MMM-YYYY"
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12} sm={12} md={0.5} lg={0.5} xl={0.5} display="flex-start" justifyContent="center">
                                <Typography variant="h6">Shift</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5}>


                                <FormControl fullWidth size="small">
                                    <Autocomplete
                                        fullWidth
                                        value={winderShiftCode}
                                        onChange={handleWinderShiftChange}
                                        size="small"
                                        style={{ fontSize: '12px' }}
                                        options={shiftCodes}
                                        getOptionLabel={(option) => `${option.shiftcode}`}
                                        renderInput={(params) =>
                                            <TextField required
                                                // helperText={errorMessage}
                                                // error={errorMessage && errorMessage.length ? true : false}
                                                {...params} variant="outlined" />}
                                    />
                                </FormControl>

                            </Grid>


                        </Grid>

                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">


                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">

                                <Typography variant="h6">Attendance status</Typography>

                            </Grid>

                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                <TextField
                                    size="small"
                                    // label="Attendance Status"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    fullWidth
                                    select
                                >
                                    <MenuItem value="P">Present</MenuItem>
                                    <MenuItem value="A">Absent</MenuItem>
                                    <MenuItem value="L">Leave</MenuItem>
                                </TextField>

                            </Grid>
                        </Grid>


                        <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                            <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">

                                <Typography variant="h6">Check-In & Out Time</Typography>

                            </Grid>
                            <Grid item xs={12} sm={12} md={1.4} lg={1.4} xl={1.4} >
                                <FormControl size="small" >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker

                                            placeholder="Check-In Time"
                                            value={checkInTime}
                                            onChange={(newValue) => setCheckInTime(newValue)}

                                            slotProps={{ textField: { size: 'small' } }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>

                            </Grid>

                            <Grid item xs={12} sm={12} md={0.1} lg={0.1} xl={0.1} >
                                <Typography>-</Typography>
                            </Grid>

                            <Grid item xs={12} sm={12} md={1.4} lg={1.4} xl={1.4} >
                                <FormControl size="small">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            placeholder="Check-Out Time"
                                            value={checkOutTime}
                                            onChange={(newValue) => {
                                                setCheckOutTime(newValue);
                                                handleCalculateDuration();
                                            }}

                                            slotProps={{ textField: { size: 'small' } }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={1.1} lg={1.1} xl={1.1}>

                                <TextField
                                    size="small"
                                    label="Duration (Min)"
                                    value={durationMins}
                                    disabled
                                    fullWidth
                                />

                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </>) || (<>    
                <ViewMonthlyAttendance  handlecallBack={handleViewAttendanceList} />
            </>)}
        </>
    );
};

export default MarkAttendance;
